// Utility function to parse featured_image that might be stored as JSON array
export const parseFeaturedImage = (featuredImage) => {
  if (!featuredImage) return null;
  
  // If it's already a string without brackets, return as is
  if (typeof featuredImage === 'string' && !featuredImage.includes('[')) {
    return featuredImage;
  }
  
  // If it's a JSON array string, parse it
  if (typeof featuredImage === 'string' && featuredImage.includes('[')) {
    try {
      const parsed = JSON.parse(featuredImage);
      return Array.isArray(parsed) && parsed.length > 0 ? parsed[0] : null;
    } catch (e) {
      // If parsing fails, return null to show placeholder
      return null;
    }
  }
  
  return featuredImage;
};

// Get the featured image URL for products (handles both new images array and legacy featured_image)
export const getProductImageUrl = (product) => {
  // Check for new images array first
  if (product.images && Array.isArray(product.images) && product.images.length > 0) {
    return `/uploads/products/${product.images[0].filename}`;
  }
  
  // Fallback to legacy featured_image
  if (product.featured_image) {
    return getFeaturedImageUrl(product.featured_image);
  }
  
  return null;
};

// Get the full image URL for featured images (legacy support)
export const getFeaturedImageUrl = (featuredImage) => {
  if (!featuredImage) {
    return null;
  }
  
  let imageName = featuredImage;
  
  // If it's a JSON array string, parse it to get the first image
  if (typeof featuredImage === 'string' && featuredImage.startsWith('[')) {
    try {
      const parsed = JSON.parse(featuredImage);
      imageName = Array.isArray(parsed) && parsed.length > 0 ? parsed[0] : featuredImage;
    } catch (e) {
      // If parsing fails, use original
      imageName = featuredImage;
    }
  }
  
  // If it's already just a filename (from processed cart data), use it directly
  if (typeof imageName === 'string' && !imageName.includes('[') && !imageName.includes('/')) {
    const url = `/uploads/products/${imageName}`;
    return url;
  }
  
  // If it already includes path, return as is
  if (typeof imageName === 'string' && imageName.includes('/')) {
    return imageName;
  }
  
  const finalUrl = imageName ? `/uploads/products/${imageName}` : null;
  return finalUrl;
};
